import { render, staticRenderFns } from "./preguntas-frecuentes.vue?vue&type=template&id=4a40f746&scoped=true&"
import script from "./preguntas-frecuentes.vue?vue&type=script&lang=js&"
export * from "./preguntas-frecuentes.vue?vue&type=script&lang=js&"
import style0 from "./preguntas-frecuentes.vue?vue&type=style&index=0&id=4a40f746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a40f746",
  null
  
)

export default component.exports